module.exports = __webpack_public_path__ + "img/waist.b8b763a5.png";